module.exports = __webpack_public_path__ + "img/other-icon.428210b4.svg";